import { render, staticRenderFns } from "./text-field.vue?vue&type=template&id=b80ab8f8&scoped=true"
import script from "./text-field.vue?vue&type=script&lang=js"
export * from "./text-field.vue?vue&type=script&lang=js"
import style0 from "./text-field.vue?vue&type=style&index=0&id=b80ab8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80ab8f8",
  null
  
)

export default component.exports